<script setup>

</script>

<template>
    <div class="terms">
      <div class="container">
        <div class="terms__wrapper">
          <h2>Terms of Use</h2>
          <h4>These Terms of Use (“Terms”) govern access to and use of Gold-Charge.com and related online resources (“Website”). The Website is operated by SOFTWAREERA LTD. By using the Website, you agree to these Terms; if you do not agree, you must stop using the Website immediately.</h4>
          <h3>1. About Gold-Charge.com</h3>
          <p>Gold-Charge.com is a technical payment connectivity platform operated by SOFTWAREERA LTD, a private limited company registered in the United Kingdom, 95 Wilton Road, Ste 717, London, England, SW1V 1BZ.</p>
          <p>Gold-Charge.com is not a bank, authorised payment institution, electronic money institution, or money services business. It does not issue payment instruments, hold customer funds, or perform deposit, lending, settlement, or remittance services.</p>
          <h3>2. Eligibility</h3>
          <p>By using the Website, you confirm that:</p>
          <ul>
            <li>you have reached the legal age of majority in your country of citizenship and residence;</li>
            <li>you have full legal authority to enter binding agreements;</li>
            <li>your use of the Website complies with all applicable laws and these Terms.</li>
          </ul>
          <p>If the Website is used on behalf of a company or organisation, you confirm that you are authorised to bind that entity to these Terms.</p>
          <h3>3. Use of the Website</h3>
          <p>Users may access publicly available Website pages for lawful and legitimate purposes only.</p>
          <p>Without prior written consent from SOFTWAREERA LTD, it is prohibited to:</p>
          <ul>
            <li>copy, reproduce, modify, reverse engineer, extract, or create derivative works from Website materials or code;</li>
            <li>distribute, sell, sublicense, or provide Website content to third parties;</li>
            <li>remove or alter copyright or proprietary notices;</li>
            <li>interfere with Website security or operation, including by attempting unauthorised access or using bots, scrapers, or automated tools;</li>
            <li>introduce malware or other harmful code; or</li>
            <li>bypass security, authentication, or access-control mechanisms.</li>
          </ul>
          <h4>SOFTWAREERA LTD may suspend or permanently restrict access to the Website at its sole discretion, with or without notice, including in cases of suspected breach, security risk, fraud prevention, regulatory requirements, or technical maintenance.</h4>
          <h3>4. Intellectual Property</h3>
          <p>All trademarks, logos, text, graphics, design elements, software, code, documentation, and other materials on the Website (“Intellectual Property”) are the exclusive property of SOFTWAREERA LTD or its licensors.</p>
          <p>Users may download or display publicly available materials for personal, non-commercial use only, provided all proprietary notices remain intact and no modification or derivative use is made.</p>
          <p>Any commercial use, reproduction, publication, or distribution of Intellectual Property without written consent is prohibited. SOFTWAREERA LTD may take legal action for any infringement.</p>
          <h3>5. Description of Services</h3>
          <p>The Website provides informational resources about the Gold-Charge technical payment gateway, including service descriptions, onboarding request forms, developer/API documentation, and support contact options. Website content is informational only and does not constitute onboarding approval, service activation, or provision of payment processing.</p>
          <h4>Enablement of payment services requires completion of merchant onboarding and is subject to eligibility checks, compliance procedures, and separate written agreements with SOFTWAREERA LTD and/or third-party providers.</h4>
          <h4>Gold-Charge.com relies on third-party banks, processors, and infrastructure vendors. Availability and performance may depend on these parties. No warranties are made regarding third-party systems.</h4>
          <h4>The Website may be updated, modified, suspended, or discontinued at any time. Alpha/beta features may be provided on a limited, test-use basis.</h4>
          <h4>Users may contact support via the Website. Valid requests will receive a response within 14 calendar days.</h4>
          <p>Website content does not constitute legal, financial, or professional advice. Where separate agreements exist, those agreements take precedence over these Terms.</p>
          <h3>6. Prohibited Activities</h3>
          <p>Users must not:</p>
          <ul>
            <li>violate applicable laws or regulations;</li>
            <li>engage in fraudulent or deceptive conduct;</li>
            <li>attempt unauthorised access to systems, APIs, data, or accounts;</li>
            <li>interfere with Website functionality or security;</li>
            <li>deploy bots, scrapers, malware, harmful code, or tools designed to extract data or disrupt systems;</li>
            <li>infringe intellectual property or privacy rights.</li>
          </ul>
          <h4>SOFTWAREERA LTD may investigate violations, restrict access, pursue legal remedies, or cooperate with law enforcement and regulatory bodies.</h4>
          <h3>7. Third-Party Services</h3>
          <p>The Website may reference or link to external platforms or service providers. SOFTWAREERA LTD does not control, endorse, or guarantee such services and is not responsible for their accuracy, security, or performance.</p>
          <p>Use of third-party services is at the user’s own risk and subject to their terms and privacy policies. SOFTWAREERA LTD is not liable for any losses arising from use of third-party services, including downtime or data handling practices.</p>
          <h3>8. No Warranties</h3>
          <p>The Website is provided on an “as is” and “as available” basis. SOFTWAREERA LTD makes no express or implied warranties, including regarding merchantability, fitness for purpose, accuracy, uninterrupted access, error-free operation, or protection against malware or harmful code. Users are responsible for implementing security measures to protect their systems. Where disclaimers cannot be excluded under law, they apply to the minimum extent permitted.</p>
          <h3>9. Limitation of Liability</h3>
          <p>To the fullest extent permitted by law, SOFTWAREERA LTD is not liable for any direct or indirect damages arising from:</p>
          <ul>
            <li>use or inability to use the Website;</li>
            <li>loss of data, revenue, business, or commercial opportunity;</li>
            <li>downtime, interruptions, errors, or security incidents;</li>
            <li>third-party infrastructure or service failures.</li>
          </ul>
          <h4>Liability, where it cannot be excluded, is limited as permitted by applicable law.</h4>
          <h3>10. Indemnification</h3>
          <p>Users agree to indemnify and hold harmless SOFTWAREERA LTD from any claims, losses, liabilities, legal fees, or damages arising from:</p>
          <ul>
            <li>misuse of the Website,</li>
            <li>violation of these Terms,</li>
            <li>infringement of rights, or</li>
            <li>unauthorised access or data misuse.</li>
          </ul>
          <h4>SOFTWAREERA LTD may assume defence of any indemnified matter, and users must cooperate when requested.</h4>
          <h3>11. Changes to Terms</h3>
          <p>SOFTWAREERA LTD may change or discontinue the Website and may amend these Terms at any time. The latest version will be posted on the Website. Continued use after changes constitutes acceptance.</p>
          <h3>12. Termination</h3>
          <p>SOFTWAREERA LTD may suspend or terminate access to the Website, with or without notice, for any lawful reason, including technical, security, compliance, or misconduct. No compensation or refunds are owed. Provisions relating to intellectual property, liability, indemnification, and governing law continue after termination.</p>
          <h3>13. Governing Law</h3>
          <p>These Terms shall be governed by and construed in accordance with the laws of the United Kingdom. Any dispute, claim, or proceeding shall fall under the exclusive jurisdiction of the courts of the United Kingdom.</p>
          <h3>14. Contact</h3>
          <p>For questions or legal requests, you may contact us via email: <a href="mailto:info@gold-charge.com">info@gold-charge.com</a></p>
          <p>Valid inquiries will be reviewed and answered within 14 calendar days, unless otherwise required by law.</p>
        </div>
      </div>
    </div>
  </template>

  <style scoped lang="scss">
    h2{
      color: #46302E;
      font-family: "Libre Caslon Text", sans-serif;
      font-size: 48px;
      font-style: italic;
      font-weight: 500;
      line-height: normal;
      padding-block: 70px 20px;
    }

    h3{
      color: #46302E;
      text-align: justify;
      font-family: "Didact Gothic", sans-serif;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding-top: 30px;
    }

    p, a, li{
      color: #46302E;
      font-family: "Didact Gothic", sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }

    h4{
      color: #46302E;
      font-family: "Didact Gothic", sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      padding-top: 30px;
    }

    ul{
      padding-left: 50px;
    }

    .terms{
      padding-block: 50px;
      background-image: url("@images/back.png");
      background-repeat: no-repeat;
      background-position: bottom;
      background-size: contain;
    }
  </style>